<template>
  <div class="express-companies">
    <div class="page-header">
      <h2><span class="breadcrumb-level">商城</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">设置</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">物流公司管理</span></h2>
    </div>
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>物流公司列表</span>
          <div class="button-group">
            <el-button type="primary" @click="handleSync" :loading="syncLoading">
              <el-icon><Refresh /></el-icon> 同步物流公司
            </el-button>
            <el-button type="info" @click="handleViewConfigured" :loading="viewConfiguredLoading">
              <el-icon><View /></el-icon> 查询同步月结账户
            </el-button>
          </div>
        </div>
        <div class="sync-tip" style="margin-top:12px">
          <el-alert title="同步提示" type="warning"
            description="点击查询同步月结账户，系统会自动更新管理系统的月结账号状态和对应账号的快递客户编码"
            show-icon :closable="false" />
        </div>
      </template>

      <el-dialog v-model="configuredAccountsDialogVisible" title="已配置物流账户" width="60%">
        <el-table :data="configuredAccountsList" stripe border style="width: 100%">
          <el-table-column prop="delivery_id" label="物流编码" />
          <el-table-column prop="delivery_name" label="物流公司名称">
            <template #default="scope">
              <div class="company-name-container">
                <span>{{ scope.row.delivery_name }}</span>
                <span v-if="scope.row.has_monthly_settlement" class="monthly-badge">月</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="biz_id" label="快递客户编码" />
          <el-table-column prop="remark" label="备注" />
        </el-table>
      </el-dialog>

      <div class="remark-info" style="margin-top:12px">
        <el-alert title="物流配置说明" type="info"
          description="已配置月结账户的物流公司将优先使用月结方式，未配置月结的则使用散单现结方式。请根据实际业务需求启用或关闭对应物流公司。"
          show-icon :closable="false" />
      </div>

      <el-table v-loading="loading" :data="companiesList" stripe border style="width: 100%; margin-top:16px">
        <el-table-column prop="delivery_id" label="物流编码" />
        <el-table-column prop="delivery_name" label="物流公司名称" />
        <el-table-column prop="has_monthly_settlement" label="是否已配置月结">
          <template #default="scope">
            <el-tag :type="scope.row.has_monthly_settlement ? 'success' : 'info'">
              {{ scope.row.has_monthly_settlement ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="biz_id" label="快递客户编码" />
        <el-table-column prop="enabled" label="启用状态">
          <template #default="scope">
            <el-switch v-model="scope.row.enabled" @change="handleStatusChange(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import * as expressCompanyApi from '../../api/expressCompany'
import { Refresh, View } from '@element-plus/icons-vue'

const loading = ref(false)
const syncLoading = ref(false)
const viewConfiguredLoading = ref(false)
const companiesList = ref([])
const configuredAccountsDialogVisible = ref(false)
const configuredAccountsList = ref([])

const loadCompanies = async () => {
  loading.value = true
  try {
    const response = await expressCompanyApi.fetchExpressCompanies()
    if (response.code === 200) {
      companiesList.value = (response.data || []).sort((a, b) => b.enabled - a.enabled)
    }
  } catch (error) {
    ElMessage.error('获取物流公司列表失败')
  } finally {
    loading.value = false
  }
}

const handleSync = async () => {
  syncLoading.value = true
  try {
    const res = await expressCompanyApi.syncExpressCompaniesFromWechat()
    if (res.code === 200) {
      ElMessage.success('同步物流公司成功')
      loadCompanies()
    } else {
      ElMessage.error('同步物流公司失败')
    }
  } catch {
    ElMessage.error('同步物流公司失败')
  } finally {
    syncLoading.value = false
  }
}

const handleStatusChange = async (company) => {
  try {
    const res = await expressCompanyApi.updateExpressCompanyStatus(company.id)
    if (res.code === 200) {
      ElMessage.success('状态更新成功')
      loadCompanies()
    } else {
      company.enabled = !company.enabled
    }
  } catch {
    company.enabled = !company.enabled
    ElMessage.error('状态更新失败')
  }
}

const handleViewConfigured = async () => {
  viewConfiguredLoading.value = true
  try {
    const res = await expressCompanyApi.getConfiguredExpressAccounts()
    if (res.code === 200) {
      configuredAccountsList.value = res.data || []
      configuredAccountsDialogVisible.value = true
    }
  } catch {
    ElMessage.error('获取已配置物流账户失败')
  } finally {
    viewConfiguredLoading.value = false
  }
}

onMounted(() => loadCompanies())
</script>

<style scoped>
.card-header { display: flex; justify-content: space-between; align-items: center; }
.button-group { display: flex; gap: 10px; }
.company-name-container { position: relative; display: inline-block; padding-right: 16px; }
.monthly-badge {
  position: absolute; top: 2px; right: 0;
  background-color: #faad14; color: white;
  font-size: 10px; padding: 2px 4px; border-radius: 10px; font-weight: bold;
}
</style>
